export function getLocationQty(item, location) {
    if (!item || !location) {
        return 0
    }

    if (item.location_stock && item.location_stock.length) {
        const row = item.location_stock.find(stock => stock.locations_id === location.id)

        if (row) {
            return row.qty
        }
    }

    if (location.qty_key && item[location.qty_key] !== undefined && item[location.qty_key] !== null) {
        return item[location.qty_key]
    }

    return 0
}

export function getLocationBin(item, location) {
    if (!item || !location) {
        return ''
    }

    if (item.location_stock && item.location_stock.length) {
        const row = item.location_stock.find(stock => stock.locations_id === location.id)

        if (row) {
            return row.bin || ''
        }
    }

    if (location.bin_key && item[location.bin_key] !== undefined && item[location.bin_key] !== null) {
        return item[location.bin_key]
    }

    return ''
}

export function buildLocationColumns(locations) {
    return (locations || []).map(location => ({
        key: location.qty_key,
        label: location.name,
        sortable: !!location.warehouse_code,
        thStyle: { 'white-space': 'nowrap' },
        visible: 1,
        location_id: location.id
    }))
}

export function initLocationStockForm(locations, existingStock) {
    const form = {}

    ;(locations || []).forEach(location => {
        const existing = (existingStock || []).find(stock => stock.locations_id === location.id)

        form[location.id] = {
            locations_id: location.id,
            qty: existing ? existing.qty : '',
            bin: existing ? (existing.bin || '') : ''
        }
    })

    return form
}

export function locationStockRows(form) {
    return Object.values(form || {}).map(row => ({
        locations_id: row.locations_id,
        qty: row.qty === '' || row.qty === null || row.qty === undefined ? 0 : parseInt(row.qty, 10) || 0,
        bin: row.bin ? String(row.bin).trim() : null
    }))
}

export function replaceLocationColumns(fields, locations) {
    const locationKeys = new Set(['qty_wh_a', 'qty_wh_b', ...locationQtyKeys(locations)])
    const locationStart = fields.findIndex(field =>
        locationKeys.has(field.key) || field.location_id != null
    )

    if (locationStart === -1) {
        return fields
    }

    // Slice from the location block; filtering the full list re-includes prefix cols (SKU/Name/QTY).
    const before = fields.slice(0, locationStart)
    const after = fields
        .slice(locationStart)
        .filter(field => !locationKeys.has(field.key) && field.location_id == null)
    const locationColumns = buildLocationColumns(locations)

    return [...before, ...locationColumns, ...after]
}

export function locationQtyKeys(locations) {
    return (locations || []).map(location => location.qty_key)
}
